export const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:8001';

export const PLAYLIST_API_PATH = '/api/v1/playlist/';

export const PLAYLIST_CONTENT_API_PATH = '/api/v1/playlist-content/';

export const CONTENT_API_PATH = '/api/v1/content/';
export const REVENUE_API_PATH = '/api/v1/revenues/';

export const DIRECT_UPLOAD_MULTIPART_START_API_PATH =
  '/api/v1/content/direct-upload-multipart/start/';
export const DIRECT_UPLOAD_MULTIPART_COMPLETE_API_PATH =
  '/api/v1/content/direct-upload-multipart/complete/';
export const DIRECT_UPLOAD_MULTIPART_PRESIGNED_URL_API_PATH =
  '/api/v1/content/direct-upload-multipart/pre-signed-url/';

export const VIDEO_SOURCE_API_PATH = '/api/v1/video-source/';

export const VIDEO_STATUS_API_PATH = '/api/v1/content/video-status/';

export const CATEGORY_API_PATH = '/api/v1/category/';
export const TAG_API_PATH = '/api/v1/tags/';

export const SEASON_API_PATH = '/api/v1/season/';

export const SERIES_API_PATH = '/api/v1/series/';

export const SEASON_SUB_PATH = '/seasons/';

export const PEOPLE_API_PATH = '/api/v1/cast/';

export const CONTRACT_API_PATH = '/api/v1/contracts/';

export const CONTRACT_UPLOAD_API_PATH = '/api/v1/contracts/upload/';

export const CONTRACT_EXPORT_API_PATH = '/api/v1/contracts/export/';

export const CONTENT_SUB_PATH = '/contents/';

export const REFRESH_API_PATH = '/api/v1/accounts/token/refresh/';

export const ADMIN_USER_API_PATH = '/api/v1/accounts/admin/users/';

export const USER_API_PATH = '/api/v1/accounts/user/';

export const LOGIN_API_PATH = '/api/v1/accounts/login/';

export const LOGOUT_API_PATH = '/api/v1/accounts/logout/';

export const PROJECT_API_PATH = '/api/v1/projects/';

export const COMPANY_API_PATH = '/api/v1/projects/companies/';

export const PLATFORM_API_PATH = '/api/v1/projects/platforms/';

export const ROLE_API_PATH = '/api/v1/roles/';

export const PERMISSION_API_PATH = '/api/v1/permissions/';

export const ACTION_HISTORY_API_PATH = '/api/v1/history/user-action-history/';

export const GENRE_API_PATH = '/api/v1/genres/';

export const ADDITIONAL_CONTENT_API_PATH = '/api/v1/content/additional-content/';

export const S3_VIDEO_SOURCE_API_PATH = '/api/v1/video-asset/asset-source/';

export const VIDEO_ASSET_API_PATH = '/api/v1/video-asset/videos/';

export const CONTENT_VIDEO_API_PATH = '/api/v1/video-asset/content-video/';

export const VIDEO_SUBTITLE_API_PATH = '/api/v1/video-asset/video-subtitle/';

export const VIDEO_THUMBNAIL_API_PATH = '/api/v1/video-asset/video-thumbnail/';

export const CONTENT_ASSET_API_PATH = '/api/v1/content/video-asset/';
